<ul [class]="cx('list')">
  @for (option of options(); track option[optionValue()]) {
    <li [class]="cx('item')" [attr.data-testid]="option[testId()]">
      <a
        [class]="cx('link')"
        [class.active]="option[optionValue()] === value()"
        href="javascript:void(0)"
        (click)="click(option[optionValue()])"
      >
        <span [class]="cx('label')">
          {{ option[optionLabel()] }}
        </span>

        @if (option[optionDescription()]) {
          <span [class]="cx('description')">
            {{ option[optionDescription()] }}
          </span>
        }
      </a>
    </li>
  }
</ul>
